import { render, staticRenderFns } from "./situation-lost.vue?vue&type=template&id=06bb3a24&lang=pug&"
import script from "./situation-lost.vue?vue&type=script&lang=js&"
export * from "./situation-lost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06bb3a24')) {
      api.createRecord('06bb3a24', component.options)
    } else {
      api.reload('06bb3a24', component.options)
    }
    module.hot.accept("./situation-lost.vue?vue&type=template&id=06bb3a24&lang=pug&", function () {
      api.rerender('06bb3a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/situation/lost/situation-lost.vue"
export default component.exports